// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"2a6b65af","161":"f9b34f43","285":"70f8ca59","485":"269d9c48","584":"c6994968","599":"71c310b3","655":"0f75c59d","667":"2fbd3eb1","803":"a3871fdb","988":"7350bf4a"}[chunkId] + ".chunk.js";
};